import React from 'react';
import i18next from 'i18next';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import TypeIcon from 'components/TypeIcon';

import styles from './styles.module.scss';

class Pill extends React.Component {
  static propTypes = {
    count: PropTypes.number.isRequired,
    onClick: PropTypes.func,
    onRef: PropTypes.func,
    attributes: PropTypes.shape({}),
    className: PropTypes.string,
    isAmp: PropTypes.bool,
  };

  static defaultProps = {
    onClick: Function.prototype,
    onRef: Function.prototype,
    attributes: {},
    className: '',
    isAmp: false,
  };

  componentWillUnmount() {
    const { onRef } = this.props;
    if (onRef) {
      onRef(undefined);
    }
  }

  determineCountDisplay = (count) => (count >= 11 ? i18next.t('SEE NEW') : `${i18next.t('SEE')} ${count || ''} ${i18next.t('NEW')}`);

  determinePluralization = (count) => (count === 1 ? i18next.t('POST') : i18next.t('POSTS'));

  render() {
    const {
      count, onClick, attributes, onRef, className: additionalClasses, isAmp,
    } = this.props;

    const unit = this.determinePluralization(count);
    const countNumber = this.determineCountDisplay(count);

    const label = `${countNumber} ${unit}`;

    return (
      <button
        type="button"
        className={classNames(
          'z-999 color-knockout-primary bg-secondary db f4 founders-cond bl-0 br-0 bt-0 bb-0',
          { [styles.ampPillButton]: isAmp },
          styles.newPostsButton,
          additionalClasses,
        )}
        onClick={onClick}
        ref={(ref) => onRef(ref)}
        {...attributes}
        data-test="pill"
      >
        <TypeIcon
          type="related-article"
          className={classNames('liveBlogButton di mr1 bg-secondary relative', styles.bullet)}
        />
        <span className="lh-title">{label}</span>
      </button>
    );
  }
}

export default Pill;
